var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "29px",
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_page_owner_MVP-2_desktop",
    transform: "translate(-1384.000000, -1003.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Action",
    transform: "translate(1367.000000, 998.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Add-person",
    transform: "translate(15.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Calendar"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 30.5084743 0 30.5084743 30.5084743 0 30.5084743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4237286,3.81355929 L24.1525422,3.81355929 L24.1525422,1.27118643 L21.6101693,1.27118643 L21.6101693,3.81355929 L8.89830502,3.81355929 L8.89830502,1.27118643 L6.35593216,1.27118643 L6.35593216,3.81355929 L5.08474572,3.81355929 C3.68644065,3.81355929 2.54237286,4.95762708 2.54237286,6.35593216 L2.54237286,26.6949151 C2.54237286,28.0932201 3.68644065,29.2372879 5.08474572,29.2372879 L25.4237286,29.2372879 C26.8220337,29.2372879 27.9661015,28.0932201 27.9661015,26.6949151 L27.9661015,6.35593216 C27.9661015,4.95762708 26.8220337,3.81355929 25.4237286,3.81355929 Z M25.4237286,26.6949151 L5.08474572,26.6949151 L5.08474572,10.1694914 L25.4237286,10.1694914 L25.4237286,26.6949151 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9830507,17.1610168 L13.9830507,13.3474575 L16.5254236,13.3474575 L16.5254236,17.1610168 L20.3389829,17.1610168 L20.3389829,19.7033897 L16.5254236,19.7033897 L16.5254236,23.516949 L13.9830507,23.516949 L13.9830507,19.7033897 L10.1694914,19.7033897 L10.1694914,17.1610168 L13.9830507,17.1610168 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEvent);
export default __webpack_public_path__ + "static/media/create-event.096fb5fb.svg";
export { ForwardRef as ReactComponent };